export const getEmployeeName = (): string => {
    try {
        const raw = localStorage.getItem("employeename") || "";

        const name =
            raw.length > 1 && raw.startsWith('"') && raw.endsWith('"')
                ? raw.slice(1, -1)
                : raw;

        return name || localStorage.getItem("username") || "";
    } catch {
        return "";
    }
};

export const getEmployeeId = (): string => {
    try {
        return localStorage.getItem("employeeid") || "";
    } catch {
        return "";
    }
};
